import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { Observable, from, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { authConfig } from '../configs/auth.config';

export const authInterceptor: HttpInterceptorFn = (request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
  const oauthService = inject(OAuthService);

  if (request.url.includes('oauth2/token')) {
    return next(request);
  }

  const token = oauthService.getAccessToken();
  if (!token) {
    return next(request);
  }

  const addAuthorizationHeader = (req: HttpRequest<unknown>, token: string): HttpRequest<unknown> =>
    req.clone({ setHeaders: { Authorization: `Bearer ${token}` } });

  const handle401Error = (req: HttpRequest<unknown>): Observable<HttpEvent<unknown>> => {
    oauthService.configure(authConfig);
    oauthService.loadDiscoveryDocumentAndLogin();

    return from(oauthService.refreshToken()).pipe(
      switchMap(() => {
        const newToken = oauthService.getAccessToken();
        const authReq = addAuthorizationHeader(req, newToken);
        return next(authReq);
      }),
      catchError(() => {
        localStorage.clear();
        window.location.href = '/';
        return throwError(() => new Error('Session expired. Please log in again.'));
      })
    );
  };

  const authReq = addAuthorizationHeader(request, token);

  return next(authReq).pipe(
    catchError((error: Error) => {
      if (error instanceof HttpErrorResponse && error.status === 401) {
        return handle401Error(request);
      } else {
        return throwError(error);
      }
    })
  );
};
